import { Typography } from '../Typography/Typography';
import { Button } from '../Button/Button';
import { Textarea, type TextareaProps } from '../Textarea/Textarea';
import './TextFieldWithPresets.css';

export interface TextFieldWithPresetsProps extends TextareaProps {
  presets: readonly string[];
  presetsLabel: string;
  heading?: string;
}

/** Presets fill a controlled multiline field; the selected text remains editable. */
export function TextFieldWithPresets({ presets, presetsLabel, heading, value, onValueChange, disabled, testId, ...fieldProps }: TextFieldWithPresetsProps) {
  return <div className="text-field-with-presets">
    {heading && <Typography as="h3" role="body/sm">{heading}</Typography>}
    <div className="text-field-with-presets__options" role="group" aria-label={presetsLabel}>
      {presets.map((text, index) => <Button key={text} variant="soft" size="small" disabled={disabled} aria-pressed={value === text} onClick={() => onValueChange(text)} testId={testId ? testId + '-preset-' + index : undefined}>{text}</Button>)}
    </div>
    <Textarea {...fieldProps} value={value} onValueChange={onValueChange} disabled={disabled} testId={testId} />
  </div>;
}
